import { useEffect } from 'react';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useState } from 'react';

export default function DateSelect({ date }) {

    const [value, setValue] = useState();

    useEffect(() => {
        if (date) {
            setValue(date)
        }
    }, [date])

    return (
        <div style={{ backgroundColor: "#fff", width: '150px' }}>
            <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
                <DatePicker
                    label="تاریخ"
                    value={value}
                    onChange={(newValue) => {
                        setValue(newValue)
                        console.log(value)
                    }}
                />
            </LocalizationProvider>
        </div>
    );
}
